import { render, staticRenderFns } from "./creativesFormatsTable.vue?vue&type=template&id=c8a8cc0a&scoped=true&lang=pug"
import script from "./creativesFormatsTable.vue?vue&type=script&lang=js"
export * from "./creativesFormatsTable.vue?vue&type=script&lang=js"
import style0 from "./creativesFormatsTable.vue?vue&type=style&index=0&id=c8a8cc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a8cc0a",
  null
  
)

export default component.exports